import { ForecastService } from './forecast.service';
import { ForecastMenuService } from './forecast-menu.service';

export const services = [ForecastService, ForecastMenuService];

export * from './forecast.service';
export * from './forecast-menu.service';
